import AsyncSelect from "react-select/async";
import { SearchFieldStyles } from "./SearchFieldStyles";
import servFabricantes from "../../services/login/servFabricantes";

const FabricantesSearchField = ({ id, field, setErrorMessage, setOpenError, setValue, value, editavel, required, watchTipoEquipamento, tipoKey }) => {
  const enumTipoEquipamento = [
    { id: 1, name: 'Módulo' },
    { id: 2, name: 'Inversor' },
    { id: 3, name: 'Outros' }
  ];

  const loadFabricantes = async () => {
    try {
      const response = await servFabricantes.Listar(watchTipoEquipamento);
      let data = response.Content.map(mapResponseToValuesAndLabels);

      return data;
    }
    catch (err) {
      setOpenError(true);
      setErrorMessage(err.response.data.Message);
    }
  }

  const mapResponseToValuesAndLabels = (data) => {
    const tipoText = getEnumText(enumTipoEquipamento, data.Tipo);
    
    let label = `(${data.CodigoAneel}) - ${data.NomeFabricante} | Tipo: ${tipoText}`;
    return { value: data.Id, label: label };
  }

  const getEnumText = (enumTipoEquipamento, id) => {
    const item = enumTipoEquipamento.find((x) => x?.id === id || x.id === id);
    return item?.name || 'Não informado';
  };

  const campoComValorErrado = {
    borderRadius: '10px',
    borderBottom: '3px solid #e03528',
  };

  const combinedStyles = {
    ...SearchFieldStyles,
    control: (base, state) => ({
      ...SearchFieldStyles.control(base, state),
      ...(required ? campoComValorErrado : {}),
      '&:hover': {
        ...(required ? campoComValorErrado : {}),
      },
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: '200px',
      overflowY: 'auto',
      margin: 0,
      padding: 0,
    }),
  };

  return (
    <AsyncSelect
      key={tipoKey}
      id={id}
      placeholder="Fabricantes"
      loadOptions={loadFabricantes}
      defaultOptions
      styles={combinedStyles}
      isDisabled={editavel}
      {...field}
      value={value}
      onChange={(data) => {
        const selectedValue = { value: data.value, label: data.label };
        field.onChange(selectedValue);
        setValue(selectedValue);
      }}
    />
  );
}

export { FabricantesSearchField };